module.exports = __webpack_public_path__ + "media/images/flags/vn-f4d75cd2153d4aff6b2df496720125b3.svg";